export default "__VITE_ASSET__d494be66__"